import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useContactsStore } from "../../store/contacts.store";

export const useContacts = () => {
  const setContacts = useContactsStore((state) => state.setContacts);

  return useMutation(PartnerApi.contacts, {
    onSuccess: (data) => {
      setContacts(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
